
import React, { useState } from 'react';
import { Mail, User, Phone, Send, Loader2 } from 'lucide-react';
import Swal from 'sweetalert2';

export default function ContactForm({ user }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: user?.user_metadata?.full_name || '',
    email: user?.email || '',
    phone: user?.user_metadata?.phone || '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://icaqghpgcoapikttehjg.supabase.co/functions/v1/send-contact-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': 'sb_publishable_7nFecSfzP1uxlrIRKOwSJA_zIf8VfgR'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Erreur lors de l'envoi");
      }

      Swal.fire({
        icon: 'success',
        title: 'Message envoyé',
        text: 'Nous avons bien reçu votre message et reviendrons vers vous dès que possible.',
        confirmButtonColor: '#3182ce'
      });

      setFormData({ ...formData, message: '' });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: "Impossible d'envoyer le message. Veuillez réessayer plus tard.",
        confirmButtonColor: '#e53e3e'
      });
    } finally {
      setLoading(false);
    }
  };

  const sectionStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '14px',
    marginTop: '5px',
    boxSizing: 'border-box'
  };

  const labelStyle = {
    display: 'block',
    fontWeight: '600',
    color: '#2d3748',
    fontSize: '14px',
    marginTop: '15px'
  };

  return (
    <div style={{ padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      <div style={{ marginBottom: '32px', textAlign: 'center' }}>
        <h1 style={{ margin: '0 0 8px 0', color: '#1a202c', fontSize: '28px', fontWeight: 'bold' }}>
          Nous contacter
        </h1>
        <p style={{ margin: 0, color: '#718096', fontSize: '16px' }}>
          Une question, un bug ou une suggestion ? Notre équipe vous répond.
        </p>
      </div>

      <div style={sectionStyle}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div>
              <label style={labelStyle}>Nom complet *</label>
              <div style={{ position: 'relative' }}>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Votre nom"
                  style={inputStyle}
                />
              </div>
            </div>
            <div>
              <label style={labelStyle}>Email *</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="votre@email.com"
                style={inputStyle}
              />
            </div>
          </div>

          <label style={labelStyle}>Téléphone (Optionnel)</label>
          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="06 00 00 00 00"
            style={inputStyle}
          />

          <label style={labelStyle}>Votre message *</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="6"
            placeholder="Comment pouvons-nous vous aider ?"
            style={{ ...inputStyle, resize: 'vertical' }}
          ></textarea>

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: '24px',
              width: '100%',
              backgroundColor: loading ? '#a0aec0' : '#3182ce',
              color: 'white',
              padding: '12px',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px'
            }}
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : <Send size={20} />}
            {loading ? 'Envoi en cours...' : 'Envoyer le message'}
          </button>
        </form>
      </div>

      <div style={{ textAlign: 'center', color: '#718096', fontSize: '14px' }}>
        <p>Ou écrivez-nous directement à : <strong>contact@savatevent.fr</strong></p>
      </div>
    </div>
  );
}
